import React, { FC } from 'react';
import RichTextEditor from '@mantine/rte';
import styles from './Form.module.scss';

export interface LocalizedRichTextEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const LocalizedRichTextEditor: FC<LocalizedRichTextEditorProps> = ({
  value,
  onChange,
  readOnly,
}: LocalizedRichTextEditorProps) => {
  return (
    <RichTextEditor
      className={styles.RichTextEditor}
      value={value || ''}
      onChange={(newValue) => onChange?.(newValue)}
      readOnly={readOnly}
    />
  );
};

LocalizedRichTextEditor.defaultProps = {
  value: undefined,
  onChange: undefined,
  readOnly: false,
};

export default LocalizedRichTextEditor;
